module.exports = __webpack_public_path__ + "static/media/TrafficSignals.86f0ef51.pdf";